import React, { Component } from 'react'
import {Chart, registerables} from "chart.js";
import 'chartjs-adapter-luxon'
import {between} from '../../timeFunctions/timeFns'

import "./MultiLineChart.css";

export default class MultiLineChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.scale = props.zoom ? props.zoom : 1;
    this.chartLineColor = '#3079BA'
    this.myLineChart = undefined;
    this.chartRef = React.createRef();
  }
 
  componentDidMount() {
    Chart.register(...registerables);
    this.buildChart();
  }

  componentDidUpdate() {
    this.scale = this.props.zoom ? this.props.zoom : this.scale;
    this.buildChart();
  }
  componentWillUnmount() {
    if (typeof this.myLineChart !== "undefined") 
      this.myLineChart.destroy();
  }
  clipToInterval (series) {
    const pr = this.props
    const result = series.filter ((i, index) => 
        between (pr.chartProps.label[index], pr.startrange, pr.endrange))
    return result
  }

  buildChart = () => {
    const myChartRef = this.chartRef.current.getContext("2d");
    let chartObj = this.chartObjCommon(this.chartLineColor);
    chartObj.type = 'line';
    if (this.props.chartProps?.series2) {
      chartObj.data.datasets.push({
        label: 'Link Quality',
        borderColor: '#A9DDD2',
        backgroundColor: '#A9DDD2',
        data: this.clipToInterval(this.props.chartProps.series2),
        yAxisID: "right-y-axis",
      })
      /*if (this.props.chartProps?.series3) {
        chartObj.data.datasets.push({
          label: 'Signal',
          borderColor: '#FBCDA3',
          backgroundColor: '#FBCDA3',
          data: this.clipToInterval(this.props.chartProps.series3),
          yAxisID: "right-y-axis",
        })} // last minute take out signal*/
        chartObj.options.scales["right-y-axis"] = {
          type: 'linear',
          position: 'right',
          grid: {display: false},
          ticks: { display: true },
          grace: '00%',
          title: {
            text:"Link Quality",
            display: true,
          },
          suggestedMin: 0,  // Set minimum to 0
          suggestedMax: 100, // Set maximum to 100
        }
    }
      if (typeof this.myLineChart !== "undefined") this.myLineChart.destroy();
      this.myLineChart = new Chart(myChartRef, chartObj);
    return;
  }

  chartObjCommon(lineColor) {
    const animationTime = this.props.chartProps.label.length < 400 ? 1000 : 0;
    const timeconfig = this.timeSeriesTicks();
    const dividedData = this.props.chartProps.data.map(value => value / 1000);
    const chartObj = {
      defaults: {
        font: "Roboto', sans-serif",
      },

      data: {
        datasets: [{
          label: 'Battery',
          data: this.clipToInterval(dividedData),
          borderColor: lineColor,
          backgroundColor: lineColor,
          fill: false,
          type: 'line',
        }],
        labels: this.clipToInterval(this.props.chartProps.label),
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: animationTime },     // general animation time 
        hover: { animationDuration: animationTime }, // hover animation time
        responsiveAnimationDuration: animationTime,  // animation duration after a resize 
        plugins: {
          legend: {display: false},
          tooltip: {
            callbacks: {
              label: function(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  if (context.parsed.y === 4294967295 || context.parsed.y === -1)
                    label += "Disconnected"
                  else 
                    label += new Intl.NumberFormat().format(context.parsed.y)
                }
                return label
              }
            }
          }
        },
        scales: {
          x: {
            type: 'time',
            distribution: 'linear',
            ...timeconfig,
            ticks: { display: true },
            grid: {display: false},
         },
          y: {
            id: 'readings',
            type: 'linear',
            position: 'left',
            ticks: { display: true },
            grid: {display: false},
            title: {text:"Battery", display: true},
            beginAtZero: false,
            suggestedMin: 1.800,
            suggestedMax: 3.600,
         },
        }
      } 
    }
    return chartObj;
  }

  timeSeriesTicks () {
    this.clipToInterval(this.props.chartProps.data)
    const timeSeries = this.clipToInterval(this.props.chartProps.label)
    if (timeSeries && timeSeries.length > 0) {
      const interval = (timeSeries[timeSeries.length-1] - timeSeries[0]) / (1000*60*60)
      const options = [{name:'hour', max: 48, scale:1}, {name:'day', max: 24*7, scale:24}, 
        {name: 'week', max:24*7*6, scale:24*7}, {name: 'month', max:Number.MAX_VALUE, scale:24*30 }]
      let unitIndex = options.findIndex (opt => opt.max >= interval)
      const step = Math.max((interval / options[unitIndex].scale) / 5, 1)
      return {time: {unit: options[unitIndex].name, stepSize: step, }}
    } 
    return {time: {unit: 'hour', stepSize: 1, }}
  }
  render() {
    return (
      <div className='chart-container' style={{ height: '300px' }}>
        <canvas id="myChart" ref={this.chartRef} />
      </div>
    )
  }
}
